import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'cstmsr-extended-toggle',
    templateUrl: './extended-toggle.component.html',
    styleUrls: ['./extended-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class ExtendedToggleComponent implements OnChanges {

	@Input() value1: string;
	@Input() value2: string;
	@Input() selected: number;
	@Input() disabled = false;
	@Input() mini: boolean = false;

	@Output() valueChanged: EventEmitter<number> = new EventEmitter<number>();

	value1Display: string = '';
	value2Display: string = '';

	constructor() {
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes) {
			if (changes['value1']?.currentValue) {
				this.value1Display = this.value1;
			}

			if (changes['value2']?.currentValue) {
				this.value2Display = this.value2;
			}

			if (changes['mini']) {
				if (changes['mini']?.currentValue) {
					this.value1Display = this.value1.substring(0, 2);
					this.value2Display = this.value2.substring(0, 2);
				}
				else {
					this.value1Display = this.value1;
					this.value2Display = this.value2;
				}
			}
		}
	}

	toggle() {
		this.selected = this.selected === 1 ? 2 : 1;

		this.valueChanged.emit(this.selected);
	}

}
